import {checkBrandIsGenderSensitive} from "./check-brand-is-gender-sensitive";

export function clearPlaceholderIfBrandIsNotGenderSensitive(statement, $context) {
    const isBrandGenderSensitive = checkBrandIsGenderSensitive($context);

    if (isBrandGenderSensitive || $context.find('.forceBrandGenderSensitive').length) {
        return statement;
    }

    $(statement).find("[data-name-male-female], [data-name-male-male]").attr('placeholder', '');

    return statement;
}
